import apiService from '../../../services/api-client';
import { DeleteCompanyResponse } from '../interfaces/delete-company';
import { GetCompaniesParams, GetCompaniesResponse } from '../interfaces/get-companies';
import { PostCompanyPayloadRequest, PostCompanyResponse } from '../interfaces/post-company';
import { PutCompanyPayloadRequest, PutCompanyResponse } from '../interfaces/put-company';

export const companiesApiService = {
  async getCompanies(params: GetCompaniesParams) {
    const { data } = await apiService().get<GetCompaniesResponse>(`companies`, {
      params: { ...params },
    });
    return data;
  },
  async postCompany(body: PostCompanyPayloadRequest) {
    const { data } = await apiService().post<PostCompanyResponse>(
      `company`,
      body,
    );
    return data;
  },
  async putCompany(id: number, body: PutCompanyPayloadRequest) {
    const { data } = await apiService().put<PutCompanyResponse>(
      `company/${id}`,
      body,
    );
    return data;
  },
  async deleteCompany(id: number) {
    const { data } = await apiService().delete<DeleteCompanyResponse>(
      `company/${id}`
    );
    return data;
  },
};
